<template lang="pug">
div
    ListItem
        ListItemMeta(:title='$t("accountInfo.contact.titleText")' :description="description") 
        template(slot="extra") 
            li
                Button.cardBtn(type="primary" @click="addData" v-if="!userInfoData.email" :disabled="!userInfoData.customerId") {{ $t('accountInfo.contact.addPersonText') }}
                Button.cardBtn(type="primary" @click="editData" v-else) {{ $t('accountInfo.contact.editPersonText') }}
    Modal(v-model="isOpened" :title="modalTitle" @on-cancel="$emit('closeModalEvent')" footer-hide width="600")
        Card(dis-hover)
            div(style="display: flex; flex-direction: row; align-items: center")
                Icon(type="md-mail")
                p.cardTitle {{ $t('accountInfo.contact.mailText') }}
            Form(style="width: 100%" ref="form" :model="data" :rules="validateRule")
                FormItem.formItem(prop="contactEmail" :label='$t("accountInfo.contact.mailAddressText")')
                    Input(prefix="md-mail" :placeholder="placeholder" v-model="data.contactEmail")
        .paymentModalFooter
            p {{ $t('accountInfo.contact.descriptionText') }}
            div(style="width: 160px;text-align: right;")
                Button.cardBtn(@click="isOpened=false") {{ $t('accountInfo.cancelBtnText') }}
                Button.cardBtn(type="primary" @click="updateMail" ) {{ $t('accountInfo.saveBtnText') }}

</template>

<script>
import { _getCustomer, _updateCustomer } from "@/api/billing";

export default {
    name: "ContactListItem",
    props: ["userInfoData"],
    data() {
        return {
            isOpened: false,
            validateRule: {},
            data: {
                contactEmail: ""
            }
        };
    },
    methods: {
        addData() {
            this.isOpened = true;
            this.actionType = "add";
        },
        editData() {
            this.isOpened = true;
            this.actionType = "edit";
        },
        async updateMail() {
            await _updateCustomer({
                groupName: this.$store.state.queryGroupName,
                customerId: this.userInfoData.customerId,
                email: this.data.contactEmail
            })
                .then(result => {
                    this.isOpened = false;
                    this.$emit("reloadUserInfoData");
                    this.$Message.success(this.$t("global.success"));
                })
                .catch(err => {
                    console.log(err);
                });
        }
    },
    mounted() {
        this.data.contactEmail = this.userInfoData.email;
    },
    computed: {
        description() {
            return !this.userInfoData.email ? this.$t("accountInfo.contact.descriptionText") : this.userInfoData.email;
        },
        modalTitle() {
            return this.actionType == "add"
                ? this.$t("accountInfo.contact.addPersonText")
                : this.$t("accountInfo.contact.editPersonText");
        },
        placeholder() {
            return !this.userInfoData.email ? this.$t("accountInfo.contact.mailAddressText") : this.userInfoData.email;
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Payment/contact/listItem.vue